import { EventGridRowModel } from "../../components/EventGrid";
import React, { ReactElement } from "react";
import { CommentInput } from "../../components/CommentInput";

export const useCommentColumn = (
  pauseVideo: () => void
): ((row: EventGridRowModel, disabled?: boolean) => ReactElement) => {
  return (row: EventGridRowModel, disabled = false) => (
    <CommentInput event={row} pauseVideo={pauseVideo} disabled={disabled} />
  );
};
